module.exports = __webpack_public_path__ + "static/media/11-8.0284469f.mp3";